import { appsCategoryTypesMap } from "app/pages/sales-intelligence/domain/apps/types/filter-values";
import type { AppOperatingSystem } from "app/pages/sales-intelligence/domain/apps/types/platform";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { SearchFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/searchFilterInstance";

import AppAndroidCategoryFilter from "../../components/filters/AppAndroidCategoryFilter/AppAndroidCategoryFilter";
import AppAndroidCategoryFilterResult from "../../components/filters/AppAndroidCategoryFilter/AppAndroidCategoryFilterResult";
import AppIosCategoryFilter from "../../components/filters/AppIosCategoryFilter/AppIosCategoryFilter";
import AppIosCategoryFilterResult from "../../components/filters/AppIosCategoryFilter/AppIosCategoryFilterResult";
import type { IAppsAndroidCategoryFilter } from "../../types/androidFiltersDto";
import type { IAppsAndroidCategoryDescriptionDto, IFindAppsDescriptionDto } from "../../types/descriptionDto";
import { appsFilterCategoryMap } from "../../types/filterCategory";

import FindAppsCategoryFilter from "./CategoryFilter";

const createCategoryFilter = (
    appOs: AppOperatingSystem,
    description: IFindAppsDescriptionDto,
): SearchFilterInstance => {
    const base = {
        key: "category",
        trackingName: "App Category",
        apiCategory: "appsFilters",
        category: appsFilterCategoryMap.apps,
        title: { key: `si.find_apps.filters.${appOs}-category.title` },
        tooltipText: { key: `si.find_apps.filters.${appOs}-category.tooltip` },
    };

    if (appOs === "ios") {
        return {
            ...base,
            filter: new FindAppsCategoryFilter({
                options: description?.iosCategory || {
                    primaryCategories: [],
                    types: [appsCategoryTypesMap.all],
                    categories: [],
                },
            }),
            filterView: AppIosCategoryFilter,
            filterResultView: AppIosCategoryFilterResult,
        };
    }

    if (appOs === "android") {
        return {
            ...base,
            filter: new FilterPanelBaseFilter<IAppsAndroidCategoryFilter, IAppsAndroidCategoryDescriptionDto>({
                options: description.androidCategory || {
                    categories: [],
                },
            }),
            filterView: AppAndroidCategoryFilter,
            filterResultView: AppAndroidCategoryFilterResult,
        };
    }

    throw new Error(`[createCategoryFilter] Unknown value: ${appOs}`);
};

export default createCategoryFilter;
